<ul nz-menu>
  <li
    nz-menu-item
    *ngFor="let filter of filters"
    [nzSelected]="isChecked(filter)"
    (click)="toggle(filter)"
  >
    <label
      nz-checkbox
      [ngModel]="isChecked(filter)"
      (ngModelChange)="toggle(filter)"
    ></label>
    <span>{{ filter.label }}</span>
  </li>
</ul>
